"use client";

import React, { useCallback } from "react";
import { EntityCommentComposer } from "@/components/entity-notes";
import { useCreateTaskNote } from "@/lib/hooks/api/tasks";

interface TaskModalCommentFooterProps {
  taskId: string;
}

/** Bottom composer for task detail modal — creates task_notes rows linked to taskId. */
export function TaskModalCommentFooter({ taskId }: TaskModalCommentFooterProps) {
  const createNote = useCreateTaskNote({ invalidateScope: "timelineOnly" });

  const onSubmit = useCallback(
    async (text: string) => {
      await createNote.mutateAsync({
        task_id: taskId,
        content: text,
        note_type: "general",
        is_internal: false,
      });
    },
    [createNote, taskId]
  );

  return (
    <EntityCommentComposer
      onSubmit={onSubmit}
      disabled={createNote.isPending}
      placeholder="Add a comment…"
      inline={true}
      className="bg-background"
    />
  );
}
